import React, { } from 'react';
import './Navbar.css';

import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import blackLogo from '../assets/logo_black.svg';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const Navbar = ({ setAuth, isAuthenticated, currentPage }: { setAuth: Function; isAuthenticated: boolean; currentPage: string; }) => {

    const { bootStrapColor } = useSelector((state: RootState) => state.config);

    const logout = async (e: React.FormEvent) => {
        await e.preventDefault();
        localStorage.removeItem("token");
        await setAuth(false);
        toast.success("Desconectado com sucesso!");
    };

    return (
        <>
            <nav className={`navbar css-navbar-height bg-${bootStrapColor} m-0 p-0`}>
                <div className="container-fluid">
                    <div className="navbar-brand d-flex">
                        <img src={blackLogo} alt="Logo" className="css-navbar-img d-inline-block align-text-top" />
                    </div>
                    <h3 className="css-navbar-display-1 m-0">Monitor Pluviométrico</h3>
                </div>
            </nav>
            <div className="computador-view">
                <nav className={`navbar css-navbar-height navbar-expand bg-${bootStrapColor} sticky-top m-0 p-0 d-flex justify-content-between`}>
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <Link to={"/home"} className="text-decoration-none">
                                <div className={currentPage === '/home' ? 'nav-link text-black active' : 'nav-link text-black'}>
                                    Home
                                </div>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to={"/postos"} className="text-decoration-none">
                                <div className={currentPage === '/postos' ? 'nav-link text-black active' : 'nav-link text-black'}>Postos</div>
                            </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <div className='nav-link dropdown-toggle text-black' data-bs-toggle="dropdown" role="button" aria-expanded="false">Registros</div>
                            <ul className="dropdown-menu">
                                <li>
                                    <Link to={"/inserir-registro"} className="text-decoration-none">
                                        <div className={currentPage === '/inserir-registro' ? "dropdown-item text-black" : "dropdown-item text-black"}>Inserir registro</div>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/consultar-registro"} className="text-decoration-none">
                                        <div className={currentPage === '/consultar-registro' ? "dropdown-item text-black" : "dropdown-item text-black"}>Consultar registro</div>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link to={"/graficos"} className="text-decoration-none">
                                <div className={currentPage === '/graficos' ? 'nav-link text-black active' : 'nav-link text-black'}>
                                    Gráficos
                                </div>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to={"/mapa-composto"} className="text-decoration-none">
                                <div className={currentPage === '/mapa-composto' ? 'nav-link text-black active' : 'nav-link text-black'} >
                                    Mapa Composto
                                </div>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to={"/mapa-detalhado"} className="text-decoration-none">
                                <div className={currentPage === '/mapa-detalhado' ? 'nav-link text-black active' : 'nav-link text-black'}>
                                    Mapa Detalhado
                                </div>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to={"/previsao"} className="text-decoration-none">
                                <div className={currentPage === '/previsao' ? 'nav-link text-black active' : 'nav-link text-black'}>
                                    Previsão
                                </div>
                            </Link>
                        </li>
                    </ul>
                    <nav className="navbar css-navbar-height sticky-top m-0 p-0 d-flex justify-content-between">
                        <ul className="nav nav-tabs">
                            {
                                isAuthenticated ?
                                    <>
                                        <li className="nav-item">
                                            <button className='btn ps-3 pe-3 d-flex' onClick={logout}> logout</button>
                                        </li>
                                    </>
                                    :
                                    <li className="nav-item">
                                        <Link to={"/login"} className="text-decoration-none">
                                            <div className={currentPage === '/login' ? 'nav-link text-black active' : 'nav-link text-black'}>
                                                Login
                                            </div>
                                        </Link>
                                    </li>
                            }
                        </ul>
                    </nav >
                </nav >
            </div>
            <div className="celular-view">
                <nav className={`navbar bg-${bootStrapColor} sticky-top m-0 p-0`}>
                    <div className="container-fluid justify-content-between">

                        {/* Título ou logo (opcional) */}
                        <span className="navbar-brand text-black"></span>

                        {/* Botão hamburguer que abre o offcanvas */}
                        <button
                            className="btn"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasMenu"
                            aria-controls="offcanvasMenu"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {/* Menu lateral offcanvas */}
                        <div
                            className="offcanvas offcanvas-end"

                            id="offcanvasMenu"
                            aria-labelledby="offcanvasMenuLabel"
                        >
                            <div className="offcanvas-header">
                                <h5 className="offcanvas-title" id="offcanvasMenuLabel">Menu</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>

                            <div className="offcanvas-body">
                                <ul className="navbar-nav">
                                    <li className="nav-item" data-bs-dismiss="offcanvas">
                                        <Link to="/home" className="nav-link text-black">Home</Link>
                                    </li>
                                    <li className="nav-item" data-bs-dismiss="offcanvas">
                                        <Link to="/postos" className="nav-link text-black">Postos</Link>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <div
                                            className="nav-link dropdown-toggle text-black"
                                            role="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            Registros
                                        </div>
                                        <ul className="dropdown-menu">
                                            <li data-bs-dismiss="offcanvas">
                                                <Link to="/inserir-registro" className="dropdown-item text-black">Inserir registro</Link>
                                            </li>
                                            <li data-bs-dismiss="offcanvas">
                                                <Link to="/consultar-registro" className="dropdown-item text-black">Consultar registro</Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="nav-item" data-bs-dismiss="offcanvas">
                                        <Link to="/graficos" className="nav-link text-black">Gráficos</Link>
                                    </li>
                                    <li className="nav-item" data-bs-dismiss="offcanvas">
                                        <Link to="/mapa-composto" className="nav-link text-black">Mapa Composto</Link>
                                    </li>
                                    <li className="nav-item" data-bs-dismiss="offcanvas">
                                        <Link to="/mapa-detalhado" className="nav-link text-black">Mapa Detalhado</Link>
                                    </li>
                                    <li className="nav-item" data-bs-dismiss="offcanvas">
                                        <Link to="/previsao" className="nav-link text-black">Previsão</Link>
                                    </li>
                                    <li className="nav-item mt-3" data-bs-dismiss="offcanvas">
                                        {isAuthenticated ? (
                                            <button className="btn btn-outline-danger w-100" onClick={logout}>Logout</button>
                                        ) : (
                                            <Link to="/login" className="btn btn-outline-primary w-100">Login</Link>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>

        </>
    );
};

export default Navbar;